import { forwardRef, useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { TextField } from "@mui/material";
import { Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import RisksIcon from "../../../assets/sidebarIcons/RisksIcon";

const InputNumberQuestion = forwardRef(
    (
        {
            payload,
            data,
            currentQuestion,
            scrollToQuestion,
            latestQuestion,
            handlePayload,
            value,
            latestStepQuestion,
            isEdit,
            handlePayloadB2C,
            handlePayloadB2B,
            nonLinearValueB2B,
            nonLinearValueB2C,
        },
        ref
    ) => {
        const [val, setVal] = useState(null);
        const [value1, setValue1] = useState(null);
        const [value2, setValue2] = useState(null);
        const [show, setShow] = useState(false);
        const [show1, setShow1] = useState(false);
        const [show2, setShow2] = useState(false);
        const { t } = useTranslation();
        const isMobile = useMediaQuery("(max-width:900px)");

        useEffect(() => {
            if (payload?.model_A.includes("B2B") && nonLinearValueB2B !== 0) {
                setValue1(nonLinearValueB2B);
            }
        }, [nonLinearValueB2B, payload?.model_A]);

        useEffect(() => {
            if (payload?.model_A.includes("B2C") && nonLinearValueB2C !== 0) {
                setValue2(nonLinearValueB2C);
            }
        }, [nonLinearValueB2C, payload?.model_A]);

        useEffect(() => {
            if (value !== 0 ) {
                if (data?.key === "turnover_A") {
                    setVal(value / 1000);
                } else {
                    setVal(value)
                }
            }
        }, [value]);


        const nextQuestionHandler = (height, option) => {

            if (data?.keyB2B || data?.keyB2B) {
                if (payload?.model_A.includes("B2B")) {
                    handlePayloadB2B(data, nonLinearValueB2B);
                } else {
                    handlePayloadB2B(data, 0);
                }

                if (payload?.model_A.includes("B2C")) {
                    handlePayloadB2C(data, nonLinearValueB2C);
                } else {
                    handlePayloadB2C(data, 0);
                }
                scrollToQuestion(data, height, nonLinearValueB2C, nonLinearValueB2B);

            } else {
                handlePayload(data, value);
                scrollToQuestion(data, height, value);
            }
        };

        const handleValue = (value) => {
            const numericValue = Number(value); 
            setVal(numericValue);
            if (data?.key === "turnover_A") {
                handlePayload(data, numericValue * 1000);
            } else {
                handlePayload(data, numericValue);
            }
        };

        useEffect(() => {
            if (payload?.model_A.includes("B2B") && !value1) {
                setShow1(true);
            } else {
                setShow1(false);
            }
            if (payload?.model_A.includes("B2C") && !value2) {
                setShow2(true);
            } else {
                setShow2(false);
            }
            if (!val) {
                setShow(true);
            } else {
                setShow(false);
            }
        }, [payload?.model_A, value1, value2, val])

        const disabledHandle = () => {
            const isB2B = payload?.model_A.includes("B2B");
            const isB2C = payload?.model_A.includes("B2C");

            if (isB2B && isB2C) {
                return !value1 || !value2;
            } else if (isB2B) {
                return !value1;
            } else if (isB2C) {
                return !value2;
            }
        };
        return (
            <div
                style={{
                    padding: isMobile ? "100px 0px" : "100px 20px",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                }}
                ref={ref}
            >
                <>
                    {data?.keyB2B || data?.keyB2B ?
                        <>
                            {payload?.model_A.includes("B2B") &&
                                <>
                                    <Typography variant="subtitle1" >
                                        {t("display_clients_number_A_B2B")}
                                    </Typography>
                                    <br></br>
                                    <Grid container>
                                        <TextField
                                            id="outlined-basic"
                                            placeholder={t(data.label)}
                                            variant="outlined"
                                            multiline={data.multiline}
                                            fullWidth
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value === "" || Number(value) >= 0 && value !== "0") {
                                                    handlePayloadB2B(data, value);
                                                    setValue1(value);
                                                }
                                            }}
                                            value={value1 === null ? "" : value1}
                                            type="number"
                                            InputProps={{
                                                sx: {
                                                    '& input[type=number]': {
                                                        MozAppearance: 'textfield',
                                                        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                            display: 'none',
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    </Grid>
                                </>
                            }
                            {show1 && (
                                <span style={{ marginTop: "4px" }} className="error-message-autocomplete">
                                    {t("input_required_field")}
                                </span>
                            )}

                            <br></br>
                            {payload?.model_A.includes("B2C") &&
                                <>
                                    <Typography variant="subtitle1" >
                                        {t("display_clients_number_A_B2C")}
                                    </Typography>
                                    <br></br>
                                    <Grid container>
                                        <TextField
                                            id="outlined-basic"
                                            placeholder={t(data.label)}
                                            variant="outlined"
                                            multiline={data.multiline}
                                            fullWidth
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value === "" || Number(value) >= 0 && value !== "0") {
                                                    handlePayloadB2C(data, value);
                                                    setValue2(value)
                                                }
                                            }}
                                            value={value2 === null ? "" : value2}
                                            type="number"
                                            InputProps={{
                                                sx: {
                                                    '& input[type=number]': {
                                                        MozAppearance: 'textfield',
                                                        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                            display: 'none',
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    </Grid>
                                </>
                            }
                            {show2 && (
                                <span style={{ marginTop: "4px" }} className="error-message-autocomplete">
                                    {t("input_required_field")}
                                </span>
                            )}
                        </>
                        :
                        <>
                            <Typography variant="subtitle1">
                                {t(data.question)}
                            </Typography>
                            <br></br>
                            <Grid container>
                                <TextField
                                    id="outlined-basic"
                                    placeholder={t(data.label)}
                                    variant="outlined"
                                    multiline={data.multiline}
                                    fullWidth
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === "" || Number(value) > 0) {
                                            handleValue(value);
                                            setVal(value)
                                        }
                                    }}
                                    value={val === null ? "" : val}
                                    type="number"
                                    InputProps={{
                                        sx: {
                                            '& input[type=number]': {
                                                MozAppearance: 'textfield', // Firefox
                                                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                    display: 'none',  // Chrome, Safari, Edge
                                                },
                                            },
                                        },
                                    }}
                                />
                                {show && (
                                    <span style={{ marginTop: "4px" }} className="error-message-autocomplete">
                                        {t("input_required_field")}
                                    </span>
                                )}
                                {data?.key === "number_of_employees_B" && val > 1000 &&
                                    <div style={{ display: "flex", gap: "7px", marginTop: "8px" }}>
                                        <RisksIcon color={"#FF840D"}></RisksIcon>
                                        <span style={{ color: "#FF840D", fontSize: "15px" }}>{t("warning_employees_B")}</span>
                                    </div>
                                }
                                {data?.key === "turnover_A" && val > 100000 &&
                                    <div style={{ display: "flex", gap: "7px", marginTop: "8px" }}>
                                        <RisksIcon color={"#FF840D"}></RisksIcon>
                                        <span style={{ color: "#FF840D", fontSize: "15px" }}>{t("warning_turnover_A")}</span>
                                    </div>
                                }
                            </Grid>
                        </>
                    }
                    {currentQuestion === data.id &&
                        currentQuestion !== latestQuestion &&
                        !(isEdit && latestStepQuestion === data.id) ? (
                        <>
                            {" "}
                            {/* <br></br> */}
                            {
                                data?.keyB2B || data?.keyB2B  ?
                                    <Button
                                        onClick={(option) => {

                                            nextQuestionHandler(ref.current.clientHeight, value);
                                        }}
                                        disabled={disabledHandle()}
                                        style={{ height: "50px" }}
                                        color="secondary"
                                        variant="contained"
                                        fullWidth
                                    >
                                        {t("next")}
                                    </Button>
                                    :
                                    <Button
                                        onClick={(option) => {

                                            nextQuestionHandler(ref.current.clientHeight, value);
                                        }}
                                        disabled={!value}
                                        style={{ height: "50px" }}
                                        color="secondary"
                                        variant="contained"
                                        fullWidth
                                    >
                                        {t("next")}
                                    </Button>
                            }
                        </>
                    ) : (
                        <></>
                    )}
                </>
            </div>
        );
    }
);

export default InputNumberQuestion;